// Toulios Advisory Group, shared client-side constants

// Hosted Fireflies AI agent for the 5–15 minute discovery analysis.
// A senior consultant prepares the detailed plan after the call and
// contacts the prospect within 1–2 business days.
export const AI_AGENT_URL =
  "https://agents.fireflies.ai/connect-to-agent?id=6a20a12d7030e3e8d730b9ef";
